import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProposalEffects } from './proposal.effects';
import { proposalReducer } from './proposal.reducer';

@NgModule({
  imports: [StoreModule.forFeature('proposal', proposalReducer), EffectsModule.forFeature([ProposalEffects])],
})
export class ProposalStoreModule {}
